<app-floorplan-upload-overlay (floorplan$)="onPlanUploaded($event)">
  <div class="container scroll h-100 p-0-24-24">
    <!-- prettier-ignore -->
    @if ((isTablet$ | async) === false) {

      @if (floorplans.length === 0) {
      <h6 class="odx-subtitle-6" i18n="@@floorplanUpload.noFloorplanYet">Sie haben noch keinen Grundrissplan hinzugefügt.</h6>
    }
    <div odxLayout="grid 3@desktop 4@tablet 6@phone">
      @for (plan of floorplans; track plan) {
        <app-project-detail-file-card
          (delete$)="onDelete(plan.floorplan)"
          (submit$)="onCardSubmit($event, plan.floorplan)"
          (click$)="openFloorplan(plan.floorplan)"
          [fileUrl]="plan.floorplan.fileUrl!"
          [fileName]="plan.floorplan.name"
          [description]="plan.floorplan.description"
          [tags]="plan.floorplan.tags"
        >
        </app-project-detail-file-card>
      }
    </div>
    }
    @else {
      <app-mobile-floorplans-warning></app-mobile-floorplans-warning>
    }
  </div>
</app-floorplan-upload-overlay>
